import MUITab from '@material-ui/core/Tab';

export default MUITab;
